'use client';

import { PropsWithChildren, useId } from 'react';
import { Box, Typography } from '@wishket/design-system';

const BottomArrow = () => {
  const gradientId = useId();

  return (
    <svg
      width="10"
      height="5"
      fill="none"
      viewBox="0 0 10 5"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute right-[64px] top-full"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5L-6.07001e-07 8.74228e-07L10 0L5 5Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          x1="10"
          x2="6"
          y1="5"
          y2="-3"
          id={gradientId}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E2DE2" />
          <stop offset="1" stopColor="#5A00DB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Tooltip = ({ children }: PropsWithChildren) => {
  return (
    <Box className="inline-flex h-7 items-center justify-center whitespace-nowrap rounded-3xl bg-gradient-primary-45 px-3">
      <Typography variant="body3" className="font-medium text-white">
        {children}
      </Typography>
      <BottomArrow />
    </Box>
  );
};
